<template>
  <b-modal
    v-model="isOpen"
    title="OTP Verification"
    centered
  
    hide-footer
    class="otp-modal"
    id="downline-rep-verification"
    @hidden="closeModal"
    size="md"
  >
    <template #modal-header>
      <div class="otp-modal-header">
        <b-button variant="close-btn" class="btn-container" @click="closeModal">
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </template>
    <b-container class="otp-modal-container">
      <div  class="otp-modal-content">

        <div v-if="!skipVerification">
        <h6>OTP Validation</h6>
        <p class="text-muted mb-2">
          Validate your {{ identifierTypeText }} via OTP
          <br />
          OTP has been sent to <strong style="word-wrap: break-word;">{{ identifier }}</strong>
        </p>
        <label class="mb-2 " id="enterotplabel">Please enter the 6 digit OTP:</label>
        <div  class="d-flex otp-inputs-wrapper">

  
        <input 
                v-for="(digit, index) in otpDigits" 
                :key="index"
                v-model.number="otpDigits[index]"
          class="form-control otp-input"
                maxlength="1"
                min="0"
                max="9"
                @input="handleOtpInput(index, $event)"
                @keydown.delete="handleOtpDelete(index, $event)"
                @keydown="preventNonNumeric($event)"
                @paste="handlePaste($event)"
                ref="otpInputs"
                :disabled="otpVerified || skipVerification"
              />
        </div>


        <div class="d-flex mt-4 gap-2 flex-wrap justify-content-center">
          <b-button
            v-if="!skipVerification"
              class="verify-btn univ-btn m-0"
              @click.prevent="verifyOtp"
              :disabled="!isOtpComplete || otpVerificationInProgress || otpVerified "
            >
            <span v-if="otpVerificationInProgress">Verifying...</span>
            <span v-else-if="otpVerified">Verified</span>
            <span v-else>Verify OTP</span>
          </b-button>
        </div>

      </div>

        <div v-if="otpValidationMessage?.message&& otpAttempted && !skipVerification" class="otp-message-container mt-2 form-group">
          <div :class="['validate-message', otpValidationMessage.type]">
            <div :class="['message-indicator', `${otpValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
              <strong :class="`${otpValidationMessage.type}-text`">{{ otpValidationMessage.title }}</strong> - 
              {{ otpValidationMessage.message }}
            </span>
          </div>
        </div>



        <div  class="d-flex align-items-center mt-2">
          <b-form-checkbox 
            v-model="skipVerification"
            
            class="skip-email-verify"
            v-if="!otpVerified && showSkipValidation && (otpValidationMessage?.type === 'error' || skipVerification)"
          >
            &nbsp;Skip {{ identifierTypeText }} verification
          </b-form-checkbox>
        
        </div>
        
        <div v-if="skipValidationMessage?.message" class="skip-message-container mt-2 form-group">
          
          <div :class="['validate-message', skipValidationMessage.type]">
            <div :class="['message-indicator', `${skipValidationMessage.type}-indicator`]"></div>
              <span class="message-text">
                <strong :class="`${skipValidationMessage.type}-text`">{{ skipValidationMessage.title }}</strong> - 
                    {{ skipValidationMessage.message }}
              </span>
          </div>
        </div>
    

        

        <div class="cancel-save-btns mt-3 d-flex justify-content-center align-items-center  gap-3">
          <b-button
            class="btn btn-secondary  cancel-btn mt-0"
            @click="closeModal"
          >
            Cancel
          </b-button>

          <b-button
            class="univ-btn m-0"
            @click="saveChanges"
            :disabled="!canSaveChanges"
          >
            Save changes
          </b-button>
        </div>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import Api from "@/resource/BaseApi";
export default {
    name: "DownlineOTPEnroll",
    props: {
        identifier: {
            type: String,
            default: "example@email.com",
        },
        type: {
            type: String,
            default: " ", // "email" or "phone"
            validator: (value) => ["email", "phone"].includes(value),
        },
        value: {
            type: Boolean,
            default: false,
        },

        
        // using the props to show the type of identifier passed from the DownlineRepPerdonalInfo.vue
        identifierTypeText: {
            type: String,
            default: "email",
        },
    },
    data() {
        return {
            otpDigits: Array(6).fill(''),
            otpVerified: false,
            skipVerification: false,
            otpValidationMessage: {},
            otpAttempted: false,
             otpVerificationInProgress: false,
             skipValidationMessage: null,
            validationStatus: null,
           validationInProgress : false,
            showSkipValidation:false,
          //  canSaveChanges:false,
        };
    },


    watch: {
       isOpen(newVal) {
      if (!newVal) {
        this.resetValidationState();
      }
    },

      skipVerification(newVal) {
      if (newVal === true) {


        this.canSaveChanges = true; // Enable save changes button
        this.skipValidationMessage = {
          type: 'success',
          title: 'Verification Skipped',
          message: this.identifierTypeText+' verification has been skipped.'
          
        };

        this.otpValidationMessage = null;
        this.validationStatus = null;
      } else {
        this.skipValidationMessage = null;
      }
    }
        
    },
    computed: {
        isOpen: {
        get() {
            return this.value;
        },
        set(val) {
            this.$emit("input", val);
        },
        },
        isOtpComplete() {
        return this.otpDigits.every((d) => d !== "");
        },


        canSaveChanges() {
      if (this.loading) return false;
      
      if (this.otpVerified) {
        return true;
      }
      else if (this.skipVerification) {
        return true;
      }
       else if (this.validationStatus && this.validationStatus.type === 'error') {
        return false;
      }
      else{
      return false;
      
      }
      }
     },
    methods: {
      resetValidationState() {
      this.otpVerified = false;
      this.skipVerification = false;
      this.otpDigits = Array(6).fill('');
      this.validationStatus = null;
      this.otpValidationMessage = null;
      this.validationInProgress = false;
      this.otpVerificationInProgress = false;
      this.otpAttempted = false;
   
      this.skipValidationMessage = null;
      this.canSaveChanges = false; // Disable save changes button
    },

    handleOtpInput(index, event) {
      // Sanitize input to numbers only
      const sanitizedValue = event.target.value.replace(/\D/g, '')
      this.otpDigits[index] = sanitizedValue
      
      // Ensure only one digit is entered
      if (event.target.value.length > 1) {
        this.otpDigits[index] = event.target.value.slice(0, 1)
        return
      }

      // Move to next input when a digit is entered
      if (sanitizedValue && index < 5) {
        this.$nextTick(() => {
          this.$refs.otpInputs[index + 1].focus()
        })
      }
      
      // Emit complete event if all digits filled
      if (this.otpDigits.every(d => d) && index === 5) {
        this.$emit('complete', this.otpDigits.join(''))
      }
    },

    handleOtpDelete(index, event) {
      // Move to previous input when backspace is pressed on an empty field
      if (!event.target.value && index > 0) {
        this.$nextTick(() => {
          this.$refs.otpInputs[index - 1].focus();
        });
      }
    },
    preventNonNumeric(event) {
      // Allow: backspace, delete, tab, escape, enter
      if (
        [8, 9, 13, 27, 46].includes(event.keyCode) ||
        // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        (event.ctrlKey && [65, 67, 86, 88].includes(event.keyCode)) ||
        // Allow: left/right arrows
        (event.keyCode >= 37 && event.keyCode <= 40)
      ) {
        return;
      }

      // Block non-numeric keys
      if (
        (event.keyCode < 48 || event.keyCode > 57) && // 0-9
        (event.keyCode < 96 || event.keyCode > 105)   // Numpad 0-9
      ) {
        event.preventDefault();
      }
    },
    handlePaste(event) {
      event.preventDefault();
      
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      
      const numericText = pastedText.replace(/[^0-9]/g, '');
      
      const otpText = numericText.slice(0, 6);
      
      this.fillOtpInputs(otpText);
    },
    fillOtpInputs(otpText) {
      this.otpDigits = Array(6).fill('');
      
      for (let i = 0; i < Math.min(otpText.length, 6); i++) {
        this.otpDigits[i] = otpText[i];
      }
      
      const focusIndex = Math.min(otpText.length, 5);
      this.$nextTick(() => {
        if (this.$refs.otpInputs && this.$refs.otpInputs[focusIndex]) {
          this.$refs.otpInputs[focusIndex].focus();
        }
      });
    },


        // method to handle the OTP verification
        async verifyOtp() {
          this.otpVerificationInProgress = true;
          this.otpAttempted = true;

          try{
            const response = await Api.post('api/v2/verify-common-otp', {
           no_attempt_limit:1,
           contact: this.identifier,
          type: this.identifierTypeText,
          otp: parseInt(this.otpDigits.join(''))
        });
        
        if (response.data.success === true || response.data.status === 'success' || response.data.verified === true) {
          this.otpVerified = true;
          this.skipVerification = false; 
          this.otpValidationMessage = {
            type: 'success',
            title: 'OTP Verified',
            message: 'Your OTP has been successfully verified.'
          };
          this.$notify('OTP verified successfully!');
          this.canSaveChanges = true; // Enable save changes button
        } else {
          this.otpVerified = false;
          this.otpValidationMessage = {
            type: 'error',
            title: 'OTP Verification Failed',
            message: response.data.message || 'Invalid OTP. Please try again.'
          };
        }
          }
          catch(error){
            console.error('OTP verification error:', error);
        this.otpVerified = false;
        
        if (error.response?.data?.message.includes('Failed to verify OTP')) {
          this.otpVerified = false;
          this.showSkipValidation = true; 

            this.otpValidationMessage = {
          type: 'error',
          title: 'Verification Error',
          message: 'Invalid OTP. Please try again.'
        };
        } else {
      
           this.$notify('OTP verification failed. an unexpected error occured', 'error');
        
        }
        
      
      } finally {
        this.otpVerificationInProgress = false;
      }
         
        },

  saveChanges() {
  if (this.otpVerified) {
    this.$emit('save', { 
      verified: true,
      skipped: false,
      identifier: this.identifier,
      type: this.identifierTypeText
    });
    this.closeModal();
  } 
  else if (this.skipVerification) {
    this.$emit('save', {
      verified: false,
      skipped: true,
      identifier: this.identifier,
      type: this.identifierTypeText
    });
    this.closeModal();
  }
  else {
    this.skipValidationMessage = {
      type: 'error',
      title: 'Error',
      message: 'Please verify the OTP or skip verification.'
    };
  }
},



    closeModal() {
      this.$emit('close');
      this.resetValidationState();
    }
    },
};

</script>

<style>
#downline-rep-verification .modal-header {
  border-bottom: none;
  padding: 0;
}

.otp-modal-container{
  padding: 0;
}
</style>

<style scoped>
.validate-message {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 0.75rem 1rem;
    position: relative;
    margin-bottom: 0.75rem;
  }
  
  .message-indicator {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .message-text {
    flex-grow: 1;
    margin-left: 0.5rem;
    color: #495057;
  }
  
  .error-text {
    color: #dc3545;
    font-size: 0.875rem !important;
  }
  
  .success-text {
    color: #28a745;
  }
  
  .warning-text {
    color: #856404;
  }
  
  .error-indicator {
    background-color: #dc3545;
  }
  
  .success-indicator {
    background-color: #28a745;
  }
  
  .warning-indicator {
    background-color: #ffc107;
  }
  
.cancel-btn {
  border-radius: 6px;
  color: #fff;
  outline: none;
  border: 0;
  text-align: center;
  padding: 10px;
  width: 100%;
  transition: all ease 0.6s;
}

/* .univ-btn{  
  max-width: 200px;
} */

.otp-modal .modal-content {
  border-radius: 10px;
  padding: 1.5rem;
}

.otp-inputs-wrapper {
  display: flex;
  margin-top: 0.5rem;
  gap: 1rem;
  justify-content: space-between;
  width: 100%;
}

.otp-inputs-wrapper .otp-input {
  height: 100%;
  aspect-ratio: 1/1;
  width: 55px;
  text-align: center;
  font-size: 1.25rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
}
.otp-inputs-wrapper .otp-input:focus{
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}


.verify-btn{
  max-width: 100%;
  /* border-color: #03c3ec ; 
  background-color: #E0F8FD;
  color: #03c3ec; */
  /* max-width: 335px; */
}
.cancel-save-btns .univ-btn{
  font-size: 1rem;
}
@media (max-width: 768px) {
  .otp-num-wrap {
    gap: 0.75rem; 
  }
}

@media (max-width: 576px) {
  .otp-inputs-wrapper {
    gap: 0.5rem;
  }
  .otp-inputs-wrapper .otp-input {
    height: 100%;
    width: 100%;
    max-width: 64px;
    aspect-ratio: 1/1;
    font-size: 1.2rem;
  }
  .verify-btn{
    min-width: 100%;
  }
  .cancel-save-btns{
    flex-direction: column;
  }
  /* .cancel-btn {
    width: 100%;
    max-width: none;
  } */
  .univ-btn{
    max-width: none;
  }
}
</style>